import axios from 'axios'

const decodeApi = axios.create({
    baseURL: `${process.env.VUE_APP_HOST_DECODE_API}`
});

export default decodeApi